import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, formatApiError } from "../../api";
import { CONTROL } from "../../constants/testIds";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { toast } from "../ui/sonner";

// Free-text Kairoo-internal notes about this gym account (support context, renewal reminders,
// escalation history) — never surfaced to the gym's own Owner Cockpit, Kairoo-staff-only.
export function GymNotesPanel({ orgId, notes, canEdit }) {
  const queryClient = useQueryClient();
  const [text, setText] = useState("");

  useEffect(() => { setText(notes || ""); }, [notes]);

  const mutation = useMutation({
    mutationFn: () => api.patch(`/control/gyms/${orgId}/notes`, { notes: text || null }),
    onSuccess: () => {
      toast.success("Notes saved.");
      queryClient.invalidateQueries({ queryKey: ["control-gym-detail", orgId] });
    },
    onError: (e) => toast.error(formatApiError(e).message),
  });

  return (
    <div className="solid-surface rounded-[14px] p-5 space-y-3">
      <h3 className="text-sm font-semibold" style={{ color: "var(--scarlet-text)" }}>Internal notes</h3>
      <p className="text-xs" style={{ color: "var(--scarlet-text-secondary)" }}>Kairoo-staff only — never visible to this gym's own Owner Cockpit.</p>
      <Textarea
        data-testid={CONTROL.gymNotesInput}
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={!canEdit}
        rows={4}
        placeholder="Support context, renewal reminders, escalation history…"
      />
      <Button data-testid={CONTROL.gymNotesSaveButton} disabled={!canEdit || mutation.isPending} onClick={() => mutation.mutate()} className="text-white" style={{ background: "var(--scarlet-accent)" }}>
        Save notes
      </Button>
    </div>
  );
}
